import React, { createContext, useContext } from 'react';
import RootStore from './RootStore';

const StoreContext = createContext(null);

export const StoreProvider = ({ children }) => {
  const rootStore = new RootStore();

  return (
    <StoreContext.Provider value={rootStore}>
      {children}
    </StoreContext.Provider>
  );
};

export const useStores = () => {
  const context = useContext(StoreContext);
  if (!context) {
    throw new Error('useStores must be used within StoreProvider');
  }
  return context;
};
